<template>
  <div v-if="expandMenu" :class="$style['overlay']" @click="openMenu()" />

  <div :class="[$style['sidemenu'], {[$style['expandMenu']]: expandMenu}]">
    <div>
      <div :class="$style['sidemenu-logo']">
        <img src="@/assets/images/logo.png" alt="logo" width="270">
      </div>
      <div :class="[$style['sidemenu-option'], $style['sidemenu-option-menu']]" @click="openMenu()">
        <Bars3Icon :class="$style['sidemenu-option-icon']" />
        <span>Menu</span>
      </div>
      <template v-if="!viewUsersBalanceTable">
        <div :class="[$style['sidemenu-option'], {[$style['active']]: isCurrentRoute('Home')}]" @click="navigateTo('Home')">
          <HomeIcon :class="$style['sidemenu-option-icon']" />
          <span>Home</span>
        </div>
        <div :class="[$style['sidemenu-option'], {[$style['active']]: isCurrentRoute('Reports')}]" @click="navigateTo('Reports')">
          <DocumentTextIcon :class="$style['sidemenu-option-icon']" />
          <span>Reports</span>
        </div>
        <div :class="[$style['sidemenu-option'], {[$style['active']]: isCurrentRoute('History')}]" @click="navigateTo('History')">
          <DocumentMagnifyingGlassIcon :class="$style['sidemenu-option-icon']" />
          <span>History</span>
        </div>
        <div :class="[$style['sidemenu-option'], {[$style['active']]: isCurrentRoute('Transactions')}]" @click="navigateTo('Transactions')">
          <ArrowsRightLeftIcon :class="$style['sidemenu-option-icon']" />
          <span>Transactions</span>
        </div>
        <div :class="[$style['sidemenu-option']]" @click="openWithdrawalModal()">
          <ArrowDownOnSquareIcon :class="$style['sidemenu-option-icon']" />
          <span>Withdrawal</span>
        </div>
        <div v-if="isMaster" :class="[$style['sidemenu-option']]" @click="toggleSubMenu('users')">
          <UsersIcon :class="$style['sidemenu-option-icon']" />
          <span>Users</span>
          <ChevronDownIcon v-if="isSubMenuOpen('users')" :class="$style['submenu-icon']"/>
          <ChevronRightIcon v-if="!isSubMenuOpen('users')" :class="$style['submenu-icon']"/>
        </div>
        <div v-if="isMaster" :class="[$style['sidemenu-option'], {[$style['active']]: isCurrentRoute('UsersBalance')}]" @click="navigateTo('UsersBalance')">
          <ArrowsRightLeftIcon :class="$style['sidemenu-option-icon']" />
          <span>Users Balance</span>
        </div>
        <transition name="fade">
          <div v-if="subMenu === 'users'" :class="$style['submenu']">
            <div :class="$style['sidemenu-suboption']" @click="openCreateUserModal()">
              Create
            </div>
            <div :class="$style['sidemenu-suboption']" @click="openDepositModal()">
              Deposit
            </div>
          </div>
        </transition>
      </template>
      <template v-else>
        <div :class="[$style['sidemenu-option'], {[$style['active']]: isCurrentRoute('UsersBalance')}]" @click="navigateTo('UsersBalance')">
          <ArrowsRightLeftIcon :class="$style['sidemenu-option-icon']" />
          <span>Users Balance</span>
        </div>
      </template>
    </div>
    <div>
      <div :class="$style['sidemenu-option']" @click="doLogout()">
        <ArrowRightStartOnRectangleIcon :class="$style['sidemenu-option-icon']" />
        <span>Logout</span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  HomeIcon,
  DocumentTextIcon,
  ArrowRightStartOnRectangleIcon,
  Bars3Icon,
  ArrowsRightLeftIcon,
  ArrowDownOnSquareIcon,
  DocumentMagnifyingGlassIcon,
  UsersIcon,
  ChevronRightIcon,
  ChevronDownIcon
 } from '@heroicons/vue/24/outline';

 import { viewOnlyUsersBalanceTableId, viewOnlyUsersBalanceTableIdxName } from '@/enums/users';

export default {
  name: 'SideBar',
  
  data() {
    return {
      expandMenu: false,
      subMenu: null,
    }
  },

  components: {
    HomeIcon,
    DocumentTextIcon,
    DocumentMagnifyingGlassIcon,
    ArrowRightStartOnRectangleIcon,
    Bars3Icon,
    ArrowsRightLeftIcon,
    ArrowDownOnSquareIcon,
    UsersIcon,
    ChevronRightIcon,
    ChevronDownIcon
  },

  mounted() {
    this.$store.dispatch('helpers/setMenu', false)
  },

  computed: {
    isMaster() {
      return this.$store.getters['auth/isMaster'];
    },
    viewUsersBalanceTable() {
      return viewOnlyUsersBalanceTableId.includes(this.$store.getters['auth/userId']) && viewOnlyUsersBalanceTableIdxName[this.$store.getters['auth/userId']] == this.$store.getters['auth/user'];
    }
  },

  methods: {
    navigateTo(routeName) {
      if(this.isCurrentRoute(routeName)) return

      this.$store.dispatch('helpers/showLoading')

      this.$router.push({ name: routeName })
    },  
    isCurrentRoute(routeName) {
      return this.$route.name === routeName
    },
    doLogout() {
      this.$store.dispatch('auth/logout');

      this.$router.push({name: 'Login'});
    },
    openMenu() {
      this.expandMenu = !this.expandMenu

      this.toggleSubMenu(null)

      this.$store.dispatch('helpers/toggleMenu')
    },
    openWithdrawalModal() {
      if(this.expandMenu) {
        this.openMenu()
      }

      this.$store.dispatch('modals/showModalWithdrawal')
    },
    openDepositModal() {
      if(this.expandMenu) {
        this.openMenu()
      }

      this.$store.dispatch('modals/showModalDeposit')
    },
    openCreateUserModal() {
      if(this.expandMenu) {
        this.openMenu()
      }

      this.$store.dispatch('modals/showModalCreateUser')
    },
    toggleSubMenu(menu) {
      this.subMenu = this.subMenu === menu ? null : menu;
    },
    isSubMenuOpen(menu) {
      return this.subMenu === menu;
    },
  }
}
</script>

<style lang="scss" module>

  .overlay {
    width: 100%;
    height: 100%;
    z-index: 5;
    background: rgba(0, 0, 0, 0.9);
    position: absolute;
  }

  @include respond-to(null, 'sm') {
    .sidemenu {
      &-logo {
        display: none;
      }

      &-option {
        display: none !important;
        padding: 6px !important;
        span {
          display: none !important;
        }
      }

      &-option-menu {
        display: flex !important;
      }
    }
  }

  .sidemenu {
    border-radius: 16px;
    background: rgba(0, 0, 0, 0.35);
    width: 200px;
    padding: 8px;
    margin: 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 7;
    transition: 1s;

    &.expandMenu {
      background: rgba(0, 0, 0, 1) !important;
      width: 150px !important;

      .sidemenu-option {
        padding: 15px 0;
        display: flex !important;
        span {
          display: flex !important;
        }
      }
    }

    .sidemenu-option-menu {
      display: none;

      &.active,
      &:hover {
        color: #D9D9D9 !important;
        background: unset !important;
        border-radius: unset !important;

        .sidemenu-option-icon{  
          color: #BBF90A !important;
        }
      }

      @include respond-to(null, 'sm') { 
        display: flex;
      }
    }

    @include respond-to(null, 'sm') {
      width: fit-content;
      margin: 0 15px 0 0;
      padding: 15px 0;
      border-radius: unset;
    }

    &-logo {
      justify-content: center;
      display: flex;
      margin-bottom: 32px;

      @include respond-to(null, 'sm') {
        display: none;
      }

      img {
        width: 170px;
        margin-top: 15px;
      }
    }

    &-option {
      color: #D9D9D9;
      font-family: $font-secondary;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 26px;
      display: flex;
      align-items: center;
      padding: 6px 16px;
      gap: 10px;
      cursor: pointer;
      margin-bottom: 5px;
      justify-content: flex-start;
  
      &-icon {
        width: 20px;
        color: #BBF90A;
      }

      &.active,
      &:hover {
        color: #232323;
        border-radius: 8px;

        .sidemenu-option-icon{  
          color: #232323;
        }
      }

      &.active {
        background: #BBF90A;
      }

      &:hover {
        background: #90C300;
      }

      @include respond-to(null, 'sm') {
        span {
          display: none;
        }
      }
    }
  }

  .submenu {
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-bottom: 10px;

    &-icon {
      width: 16px;
      height: 16px;
      margin-left: auto;
      color: #BBF90A;
    }
  }

  .sidemenu-suboption {
    color: #D9D9D9;
    font-family: $font-secondary;
    font-size: 14px;
    cursor: pointer;
    padding: 6px 10px;
    border-radius: 8px;

    &:hover {
      background: #90C300;
      color: #232323;
    }
  }
</style>
